import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";
 
export class CTRL_517 implements Validator { 
 
    public static id = 'CTRL_517'; 
    private message = 'error.ctr_517'; //message d’erreur en dur, à terme dans un JSON FR ou EN 
 
 
 
 
    validate(form: any, map) { 
 
 
        // vérifier si la règle est applicable sur mon formulaire 
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_517.id); 
 
 
        if (rgs.length > 0) { 
            for (var rg of rgs) { 
                const ctrl = form.controls[rg]; 
			//ajout du STEP_ID sur le champ 
                const inputNameWithStepId = map.get(ctrl.value.rgCtrls.obj_517); 
                const inputCtrl = form.controls[inputNameWithStepId]; 
                if (this.isNotPattern(inputCtrl)) { 
                    // placer le message d'erreur 
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message }; 
                } else { 
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false }; 
                } 
            } 
        } 
    } 

    isNotPattern(value): boolean{
        return (value == undefined || value == null || value == '' || ! value.errors?.pattern);
    }
} 
 
